import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Button, Checkbox, Divider, Grid, Input, InputLabel, Paper, TextField, Typography } from '@mui/material'

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import karmaStyles from '../../styles/KarmaPool.module.css'
import CauseCardComponent from './causes/CauseCardComponent';
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import DashboardBackButtonComponent from './footer/DashboardBackButtonComponent';
import { Link } from 'react-router-dom';
import DashboardFAQComponent from './DashboardFAQComponent';



function DashboardFAQ() {

    const theme = useTheme();
    const isMediumScreenSize = useMediaQuery(theme.breakpoints.up('sm'));

    const karmaContext = useKarmaPoolContext();

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    RedirectIfNotLoggedIn();

    const [faqSection, setFaqSection] = useState("general");

    function ChangeSelected(selected) {
        setFaqSection(selected);
    }

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    homeEnabled={true} />
            </Box>
            <Box className={karmaStyles.homepageBox3}>
                <DashboardFAQComponent />
            </Box>
            <DashboardBackButtonComponent urlSuffix={""} />
        </>
    );


}

export default DashboardFAQ;